import React from 'react';
import {
  Backdrop,
  Box,
  Button,
  Modal,
  Fade,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function UserUploadModal({ show, handleCloseModal, handleUpload }) {
  const [file, setFile] = React.useState(null);

  const handleUploadDocument = (e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  return (
    <Modal
      open={show}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Fade in={show}>
        <Box
          sx={{
            minHeight: 220,
            width: 500,
            bgcolor: 'white',
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            py: 2,
            borderRadius: '8px',
          }}>
          <Box>
            <Box display="flex" justifyContent={'space-between'}>
              <Box fontFamily={'Rubik'} fontSize={18} fontWeight={500} mb={2}>
                Bulk Upload Akadmy Users
              </Box>
              <Box sx={{ cursor: 'pointer' }}>
                <CloseIcon fontSize="medium" onClick={handleCloseModal} />
              </Box>
            </Box>

            <Box mt={2}>
              <Typography style={{ fontSize: 14 }}>
                <ol>
                  <li>
                    Download the{' '}
                    <a
                      href="/akademy_users_bulk_upload_template.csv"
                      download="akademy_users.csv">
                      template
                    </a>
                    .{' '}
                  </li>
                  <li>Start adding rows without removing the header.</li>
                  <li>Upload the file </li>
                </ol>
              </Typography>
            </Box>
            <Box mt={2}>
              <input
                accept=".csv"
                id="upload-brochure"
                type="file"
                onChange={handleUploadDocument}
              />
              <Typography style={{ fontSize: 12 }}>
                Upload a .csv file (max size 2mb)
              </Typography>
            </Box>
          </Box>
          <Box display={'flex'} justifyContent="flex-end">
            <Box mr={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCloseModal}>
                Cancel
              </Button>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleUpload(file)}
              disabled={file === null}>
              Upload
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default UserUploadModal;
